module.exports = __webpack_public_path__ + "static/media/ucc_label_icon.d4de7b77.svg";